<template>
	<div class="modal-wrapper">
		<div class="full-container bg-white">
			<div class="modal-inner">
				<button class="modal-btn" @click="onClose">
					&times;
				</button>
				<div v-html="$t('plans.wizard.klarnaModalText', {termsLink: 'https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/account-terms'})" />
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardKlarnaInfo',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
